/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

export enum EOptionType {
  CHANGE_PIN = 'CHANGE_PIN',
  ACTIVATE_PARENTAL = 'ACTIVATE_PARENTAL',
  ACTIVATE_SUBTITLE = 'ACTIVATE_SUBTITLE',
  AUDIO_DESCRIPTION = 'AUDIO_DESCRIPTION',
  PURCHASE_PIN = 'PURCHASE_PIN',
  AGE_RATING = 'AGE_RATING',
}

export enum EChangePinState {
  INIT = 'INIT',
  RESET = 'RESET',
  ASK_DEFAULT_PIN = 'ASK_DEFAULT_PIN',
  DEFAULT_PIN_VALIDATE = 'DEFAULT_PIN_VALIDATE',
  ASK_NEW_PIN = 'ASK_NEW_PIN',
  CONFIRM_NEW_PIN = 'CONFIRM_NEW_PIN',
  PINS_MISSMATCH = 'PIN_MISSMATCH',
  PINS_MISSMATCH_TRY_AGAIN = 'PINS_MISSMATCH_TRY_AGAIN',
  PINS_MATCH = 'PINS_MATCH',
  PIN_CHANGED_SUCCESS = 'PIN_CHANGED_SUCCESS',
  PIN_CHANGED_ERROR = 'PIN_CHANGED_ERROR',
  PIN_CHANGED_SUCCESS_CLOSE_DIALOG = 'PIN_CHANGED_SUCCESS_CLOSE_DIALOG',
}
export interface IOption {
  text: string;
  key: string;
  value?: string | boolean;
  type: EOptionType;
  disabled?: boolean;
  isSelected?: boolean;
}
